import { create } from 'zustand'
import type { ModalState } from '@/types'

interface ModalStore extends ModalState {
  open: (type: ModalState['type'], props?: Record<string, unknown>) => void
  close: () => void
}

export const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  type: null,
  props: undefined,

  open: (type, props) => set({ isOpen: true, type, props }),
  close: () => set({ isOpen: false, type: null, props: undefined }),
}))
